<template>
    <div class="form">
        <div class="form__section">
            <div class="form__title">Treibstoff und Tankstellenbetreiber</div>
            <div class="form__fields">

                <!-- Fuel type -->
                <div class="form__field-row">
                    <SmrSelect 
                        :options="fuelsOptions" 
                        :value="data.fuels" 
                        :output-array="true" 
                        :tracking-data="trackingData"
                        @change="fieldChangeHandler($event, 'fuels')"
                    /> <!-- todo: placeholder -->
                </div>

                <!-- Station operator -->
                <div class="form__field-row">
                    <SmrSelect 
                        :options="operatorOptions" 
                        :value="data.operator" 
                        :multiple="true" 
                        :placeholder="`Filtern Sie die Ergebnisse nach${mobile ? '<br>' : ''} bestimmten Tankstellenbetreibern`" 
                        @change="fieldChangeHandler($event, 'operator')"
                    />
                </div>

            </div>
        </div>

        <!-- Operation mode options -->
        <div class="form__section">
            <div class="form__title">Betriebsart filtern</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.operationMode" 
                        :options="operationModeOptions"
                        :outputArray="false"
                        :single-choice-checkbox="true"
                        @change="fieldChangeHandler($event, 'operationMode')"
                    />
                </div>
            </div>
        </div>

        <!-- Services options -->
        <div class="form__section">
            <div class="form__title">Services</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.services" 
                        :options="servicesOptions"
                        :outputArray="true"
                        @change="fieldChangeHandler($event, 'services')"
                    />
                </div>
            </div>
        </div>

        <!-- Other options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>

        <!-- Add new gas station -->
        <!-- <div class="form__section">
            <div class="form__fields form__fields--columns form__fields--columns--2">
                <div class="form__field-row">
                    <SmrFormButton 
                        href="#href" 
                        :new-tab="true"
                        label="Neue Tankstelle hinzufügen"
                        icon="IconPlusCircle"
                    />
                </div>
            </div>
        </div> -->

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrSelect from '@/components/form/SmrSelect.vue'
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import { getPoiConfig } from '@/utils/poi-data/poi-config'

// import SmrFormButton from '@/components/form/SmrFormButton.vue'
export default {
    components: {
        SmrSelect,
        SmrChoiceGroup,
        // SmrFormButton
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            fuelsOptions: getPoiConfig(this.optionsId).types,
            operatorOptions: getPoiConfig(this.optionsId).categories[0].children,
            operationModeOptions: [
                {value: 'MACHINE', label: 'Automaten-Tankstelle'},
                {value: 'CLERK', label: 'Tankstelle mit Bedienung'},
                {value: 'SELF_SERVICE', label: 'Selbstbedienungstankstelle'},
            ],
            servicesOptions: [
                {value: 'CAR_WASH', label: 'Waschanlage'},
                {value: 'CAR_WORKSHOP', label: 'Werkstatt'},
                {value: 'SHOP', label: 'Shop'},
            ],
            trackingData: {
                category: 'Gas Stations',
                name: 'gas_station',
                action: 'Settings',
                prefix: 'fuel_'
            },
        }
    },
    mounted() {
        if(this.selectedFuelType !== this.data.fuels[0]) {
            this.data.fuels = [this.selectedFuelType]
        }
    },
    computed: {
        ...mapGetters(['user', 'mobile', 'selectedFuelType']),
        otherOptions() {
            return [
                {value: 'openNextHour',label: 'In der nächsten Stunde geöffnet'},
                {value: 'oeamtcPartner', label: 'Nur Vorteilspartner'},
                {value: 'openAllDay', label: '24 h geöffnet'},
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},

            ]
        }
    }
}
</script>
